// 公共路由配置
export const commonRoutes = [
  {
    name: "Index",
    path: "/",
    meta: { title: "首页" },
    component: () => import("@/views/Index.vue"),
  },
  {
    name: "403",
    path: "/403",
    meta: { title: "无权限访问" },
    component: () => import("@/views/403.vue"),
  },
  {
    name: "NotFound",
    path: "/:all(.*)",
    meta: { title: "页面没有找到" },
    component: () => import("@/views/404.vue"),
  }
];

// 用户认证相关路由
export const authRoutes = [
  {
    name: "login",
    path: "/login",
    meta: { title: "用户登录" },
    component: () => import("@/views/Login.vue"),
  },
  {
    name: "login-callback",
    path: "/login/callback",
    meta: { title: "用户登录" },
    component: () => import("@/views/LoginCallback.vue"),
  },
  {
    name: "register",
    path: "/register",
    meta: { title: "用户注册" },
    component: () => import("@/views/Register.vue"),
  },
  {
    name: "resetpassword",
    path: "/resetpassword",
    meta: { title: "重置密码" },
    component: () => import("@/views/Resetpassword.vue"),
  },
  {
    name: "chat-export",
    path: "/chat/export",
    meta: { title: "导出会话记录" },
    component: () => import("@/views/ChatExport.vue"),
  },
  {
    name: "payReturn",
    path: "/payReturn",
    meta: { title: "支付回调" },
    component: () => import("@/views/PayReturn.vue"),
  }
];

// 特殊页面路由
export const specialRoutes = [
    {
    name: "nav",
    path: "/nav",
    meta: { title: "海牛AI实验室" },
    component: () => import("@/views/Nav.vue"),
  },
  {
    name: "song",
    path: "/song/:id",
    meta: { title: "音乐播放" },
    component: () => import("@/views/tools/music/Song.vue"),
  },
  
  {
    name: "asr",
    path: "/asr",
    meta: { title: "实时语音识别" },
    component: () => import("@/views/tools/audio/FunAsrRealtime.vue"),
  },
];